import Button from 'components/Button/Button';
import NoData from 'components/NoResultsFound/NoData';
import Text from 'components/Text/Text';
import { ILocalizationContext, LocalizationContext } from '../../localizationState/localizationContext';
import {
	EditRestaurantContext,
	IEditRestaurantContext,
} from 'modules/CustomersAndRestaurants/Restaurants/EditRestaurant/editRestaurantState/editRestaurantContext';
import InputFields from './components/InputFields/InputFields';
import LanguageBar from './components/LanguageBar/LanguageBar';
import ModalWindows from './components/ModalWindows/ModalWindows';
import Sidebar from './components/Sidebar/Sidebar';
import React, { useContext, useEffect, useState } from 'react';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import style from './ViewMode.module.scss';

const ViewMode: React.FC = () => {
	const { changeTypeOfModalWindow, changeMode, selectedLanguage, groups, loading } =
		useContext<ILocalizationContext>(LocalizationContext);
	const { restaurantLanguages } = useContext<IEditRestaurantContext>(EditRestaurantContext);
	const [isFirstEntry, setIsFirstEntry] = useState(true);

	useEffect(() => {
		if (isFirstEntry && loading) {
			setIsFirstEntry(false);
		}
	}, [loading]);

	const openNewWordingModal = () => {
		changeTypeOfModalWindow('addWording');
	};

	const openEditWordingsPage = () => {
		changeMode('edit');
	};

	return (
		<div className={style.container} data-test="ViewMode">
			{groups.length ? (
				<>
					<div className={style.sidebar}>
						<Sidebar items={groups} />
					</div>
					<div className={style.content}>
						<div className={style.controls}>
							<LanguageBar items={restaurantLanguages} />
							<div className={style.navigateButtons}>
								{/* <Button // TODO KMD-8157 (delete all logic later)
									theme="primaryBlue"
									icon={
										<svg className={style.icon}>
											<use xlinkHref={`${breadcrumbs}#plus`} />
										</svg>
									}
									iconPosition="pre"
									onClick={openNewWordingModal}>
									<Text
										translationNameSpace="form"
										translationKey="addNewLabelButton"
										asFragment={true}
									/>
								</Button> */}
								<Button
									icon={
										<svg className={style.icon}>
											<use xlinkHref={`${breadcrumbs}#pencil`} />
										</svg>
									}
									iconPosition="pre"
									onClick={openEditWordingsPage}>
									<Text
										translationNameSpace="form"
										translationKey="editWordingsButton"
										asFragment={true}
									/>
								</Button>
							</div>
						</div>
						<div className={style.fieldsContainer}>
							{restaurantLanguages.map((el) => (
								<InputFields
									key={el.languageId}
									languageId={el.languageId}
									isVisible={selectedLanguage?.id === el.languageId}
								/>
							))}
						</div>
					</div>
				</>
			) : (
				<>{!loading && !isFirstEntry ? <NoData /> : null}</>
			)}
			<ModalWindows />
		</div>
	);
};

export default ViewMode;
